import { render, staticRenderFns } from "./Fittings.vue?vue&type=template&id=4318244f&scoped=true"
import script from "./Fittings.vue?vue&type=script&lang=js"
export * from "./Fittings.vue?vue&type=script&lang=js"
import style0 from "./Fittings.vue?vue&type=style&index=0&id=4318244f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318244f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4318244f')) {
      api.createRecord('4318244f', component.options)
    } else {
      api.reload('4318244f', component.options)
    }
    module.hot.accept("./Fittings.vue?vue&type=template&id=4318244f&scoped=true", function () {
      api.rerender('4318244f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fittings/Fittings.vue"
export default component.exports